(function () {
  if (window.__PDPV3_ARTWORK_BRIDGE__) return;
  window.__PDPV3_ARTWORK_BRIDGE__ = true;
  var TARGET_PRODUCT_IDS = ['15113446752640', '8775851933926', '7783963951334', '15755000250752', '7433090334950', '4403399786558'];

  function onReady(fn) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', fn);
      return;
    }
    fn();
  }

  function getVariantImage(variant) {
    var featuredMedia = variant && variant.featured_media;
    var image = variant && variant.featured_image;
    if (!image && featuredMedia) {
      image = featuredMedia.preview_image || featuredMedia;
    }
    var src = image && (image.src || image.url);
    if (!src) return null;
    return {
      src: String(src),
      width: Number(image.width) || 0,
      height: Number(image.height) || 0,
      variantId: variant.id || ''
    };
  }

  function applyVariantImage(variant, artworkOverride) {
    var image = arguments.length > 1 ? artworkOverride : getVariantImage(variant);
    var roots = document.querySelectorAll('.pdpv3m-root, .pdpv3d-root');
    if (!roots.length) return false;

    var artworkLoadToken = {};
    var restoredExistingOverride = false;
    var activeImages = null;

    Array.prototype.forEach.call(roots, function (root) {
      root.__pdpv3ArtworkLoadToken = artworkLoadToken;
      if (!root.__pdpv3BaseImages) {
        var hasStoredBase = root.hasAttribute('data-base-image-fallback');
        root.__pdpv3BaseImages = {
          landscape: hasStoredBase ? (root.dataset.baseImageLandscape || '') : (root.dataset.imageLandscape || ''),
          portrait: hasStoredBase ? (root.dataset.baseImagePortrait || '') : (root.dataset.imagePortrait || ''),
          square: hasStoredBase ? (root.dataset.baseImageSquare || '') : (root.dataset.imageSquare || ''),
          fallback: hasStoredBase ? (root.dataset.baseImageFallback || '') : (root.dataset.imageFallback || '')
        };
        if (!hasStoredBase) {
          root.dataset.baseImageLandscape = root.__pdpv3BaseImages.landscape;
          root.dataset.baseImagePortrait = root.__pdpv3BaseImages.portrait;
          root.dataset.baseImageSquare = root.__pdpv3BaseImages.square;
          root.dataset.baseImageFallback = root.__pdpv3BaseImages.fallback;
        }
      }

      // Keep the navigation marker without resetting an already-correct base
      // image. A newly inserted mirror also reaches this path while 3D is off.
      if (variant && variant.id) root.dataset.artworkVariantId = String(variant.id);
      else delete root.dataset.artworkVariantId;
      var hadArtworkOverride = !!root.dataset.variantImage;
      if (!image && !hadArtworkOverride) return;

      var nextImages = image ? {
        landscape: image.src,
        portrait: image.src,
        square: image.src,
        fallback: image.src
      } : root.__pdpv3BaseImages;

      if (!image && root.dataset.variantImage) restoredExistingOverride = true;
      root.dataset.imageLandscape = nextImages.landscape;
      root.dataset.imagePortrait = nextImages.portrait;
      root.dataset.imageSquare = nextImages.square;
      root.dataset.imageFallback = nextImages.fallback;
      if (image) root.dataset.variantImage = image.src;
      else delete root.dataset.variantImage;
      if (root.dataset.artworkSource === 'modern-map-design' && image) root.dataset.designImage = image.src;
      if (image && image.width > 0 && image.height > 0) {
        root.dataset.variantImageAspectRatio = String(image.width / image.height);
      } else {
        delete root.dataset.variantImageAspectRatio;
      }
      if (!activeImages) activeImages = nextImages;

      var artImage = root.querySelector('.pdpv3m-art-image, .pdpv3d-art-image');
      var fallbackSrc = nextImages.landscape || nextImages.portrait || nextImages.square || nextImages.fallback;
      if (artImage) {
        if (!artImage.__pdpv3BaseResponsiveImage) {
          artImage.__pdpv3BaseResponsiveImage = {
            // A mirror cloned while 3D is active has no DOM expando cache.
            // Its copied base-image metadata still identifies the plain art.
            src: hadArtworkOverride
              ? (root.__pdpv3BaseImages.landscape || root.__pdpv3BaseImages.portrait || root.__pdpv3BaseImages.square || root.__pdpv3BaseImages.fallback)
              : artImage.getAttribute('src'),
            srcset: artImage.getAttribute('srcset'),
            sizes: artImage.getAttribute('sizes')
          };
        }

        // A responsive srcset takes precedence over img.src. Remove the
        // Liquid-provided candidates while a connected variant artwork is
        // active, otherwise the browser keeps displaying the original image.
        if (image) {
          artImage.removeAttribute('srcset');
        } else {
          var baseResponsiveImage = artImage.__pdpv3BaseResponsiveImage;
          fallbackSrc = baseResponsiveImage.src || fallbackSrc;
          if (baseResponsiveImage.srcset) artImage.setAttribute('srcset', baseResponsiveImage.srcset);
          else artImage.removeAttribute('srcset');
          if (baseResponsiveImage.sizes) artImage.setAttribute('sizes', baseResponsiveImage.sizes);
          else artImage.removeAttribute('sizes');
        }

        if (fallbackSrc && artImage.getAttribute('src') !== fallbackSrc) artImage.src = fallbackSrc;
      }
    });

    if (!image && !restoredExistingOverride) return false;

    Array.prototype.forEach.call(document.querySelectorAll(
      '.product-main-slide[data-feature="visualiser"] .pdpv3-photoswipe-proxy'
    ), function (proxy) {
      if (!proxy.__pdpv3BaseZoom) {
        proxy.__pdpv3BaseZoom = {
          src: proxy.getAttribute('data-photoswipe-src') || '',
          width: proxy.getAttribute('data-photoswipe-width') || '',
          height: proxy.getAttribute('data-photoswipe-height') || ''
        };
      }
      var zoom = image || proxy.__pdpv3BaseZoom;
      if (zoom.src) proxy.setAttribute('data-photoswipe-src', zoom.src);
      if (zoom.width) proxy.setAttribute('data-photoswipe-width', String(zoom.width));
      if (zoom.height) proxy.setAttribute('data-photoswipe-height', String(zoom.height));
    });

    var activeSrc = image ? image.src : (activeImages.landscape || activeImages.portrait || activeImages.square || activeImages.fallback);
    if (!activeSrc) return false;
    var thumbSrc = activeImages.landscape || activeSrc;
    var visualiserThumb = document.querySelector('.custom-product__thumb-item--visualiser .product__thumb');
    if (visualiserThumb) {
      var thumbArt = visualiserThumb.querySelector('.custom-product-landscape-img-thumb');
      if (!thumbArt) {
        thumbArt = document.createElement('img');
        thumbArt.className = 'custom-product-landscape-img-thumb';
        thumbArt.alt = 'Visualiser thumbnail artwork';
        visualiserThumb.appendChild(thumbArt);
      }
      if (thumbArt.getAttribute('src') !== thumbSrc) thumbArt.setAttribute('src', thumbSrc);
    }
    Array.prototype.forEach.call(document.querySelectorAll('.pdpv3-target-thumb-art'), function (thumbArt) {
      if (thumbArt.getAttribute('src') !== thumbSrc) thumbArt.setAttribute('src', thumbSrc);
    });

    function notifyArtworkChange(width, height) {
      document.dispatchEvent(new CustomEvent('pdpv3:artwork-change', {
        detail: {
          src: activeSrc,
          images: activeImages,
          width: width,
          height: height,
          variantId: variant && variant.id || ''
        }
      }));
    }

    var preloader = new Image();
    preloader.decoding = 'async';
    if (image && image.premade) {
      preloader.onload = function () {
        var width = preloader.naturalWidth;
        var height = preloader.naturalHeight;
        if (!(width > 0 && height > 0)) return;
        var active = false;
        Array.prototype.forEach.call(roots, function (root) {
          // Ignore a late load after removing 3D or switching artwork/variant.
          if (root.__pdpv3ArtworkLoadToken !== artworkLoadToken) return;
          root.dataset.variantImageAspectRatio = String(width / height);
          active = true;
        });
        if (!active) return;
        // Reuse the visualisers' forced layout pass, now with the decoded
        // image's actual proportions instead of the original product image.
        notifyArtworkChange(width, height);
      };
    }
    preloader.src = activeSrc;
    notifyArtworkChange(image ? image.width : 0, image ? image.height : 0);
    return true;
  }

  function getInitialVariant() {
    var productData = window.__THEME_PRODUCT_DATA__;
    var variants = productData && Array.isArray(productData.variants) ? productData.variants : [];
    if (!variants.length) return null;

    var variantId = '';
    try {
      variantId = new URLSearchParams(window.location.search || '').get('variant') || '';
    } catch (error) {}

    if (!variantId) {
      var masterSelect = document.querySelector('form[action*="/cart/add"] [name="id"], select[name="id"]');
      variantId = masterSelect ? masterSelect.value : '';
    }

    for (var i = 0; i < variants.length; i += 1) {
      if (String(variants[i].id) === String(variantId)) return variants[i];
    }
    return variants[0] || null;
  }

  onReady(function () {
    var productData = window.__THEME_PRODUCT_DATA__;
    // The modern map designer supplies finished poster artwork, rather than a
    // variant photo. Keep it through size/finish changes and late room mirrors.
    if ((productData && String(productData.productId) === '7975672152294') ||
        document.querySelector('[data-artwork-source="modern-map-design"]')) {
      if (window.UniqueMapsVisualiserArtwork) return;
      var posterImage = null;
      var posterVariant = getInitialVariant();
      function syncPoster() {
        document.querySelectorAll('.pdpv3m-root, .pdpv3d-root').forEach(function (root) {
          root.dataset.artworkSource = 'modern-map-design';
        });
        applyVariantImage(posterVariant, posterImage);
      }
      window.UniqueMapsVisualiserArtwork = {
        set: function (image) {
          posterImage = image;
          syncPoster();
          // A single visualiser starts on a later, hidden gallery slide. Its
          // runtime may still be deferred when the first poster arrives.
          if (typeof window.__pdpv3LoadRuntime === 'function') {
            window.__pdpv3LoadRuntime('modern-map-design').catch(function () {});
          }
        }
      };
      document.addEventListener('variant:change', function (event) {
        posterVariant = event && event.detail && event.detail.variant || posterVariant;
        syncPoster();
      });
      new MutationObserver(function () {
        if (!posterImage) return;
        var roots = document.querySelectorAll('.pdpv3m-root, .pdpv3d-root');
        if (Array.prototype.some.call(roots, function (root) {
          return root.dataset.variantImage !== posterImage.src;
        })) syncPoster();
      }).observe(document.body, { childList: true, subtree: true });
      syncPoster();
      document.dispatchEvent(new CustomEvent('pdpv3:artwork-ready'));
      return;
    }
    var usesVariantArtwork = !!productData &&
      TARGET_PRODUCT_IDS.indexOf(String(productData.productId || '')) !== -1;
    var premadeRoot = document.querySelector('.pdpv3m-root[data-premade-image], .pdpv3d-root[data-premade-image]');
    if (!usesVariantArtwork && !premadeRoot) return;

    var currentVariant = getInitialVariant();
    var lastSignature = '';

    function syncArtwork() {
      var toggle = document.querySelector('.unique3dpm_checkbox input[type="checkbox"]');
      var image = usesVariantArtwork ? getVariantImage(currentVariant) : null;
      if (premadeRoot && toggle && toggle.checked && !toggle.disabled) {
        image = {
          premade: true,
          src: premadeRoot.dataset.premadeImage,
          width: Number(premadeRoot.dataset.premadeImageWidth) || 0,
          height: Number(premadeRoot.dataset.premadeImageHeight) || 0
        };
      }
      var roots = document.querySelectorAll('.pdpv3m-root, .pdpv3d-root');
      var signature = JSON.stringify([image, currentVariant && currentVariant.id, roots.length]);
      if (signature === lastSignature) return;
      lastSignature = signature;
      // Keep the current variant marker for theme navigation, even when the
      // optional premade artwork takes precedence over its featured image.
      applyVariantImage(usesVariantArtwork || image ? currentVariant : null, image);
    }

    syncArtwork();
    document.addEventListener('variant:change', function (event) {
      currentVariant = event && event.detail && event.detail.variant;
      syncArtwork();
    });
    document.addEventListener('change', function (event) {
      if (event.target && event.target.matches('.unique3dpm_checkbox input[type="checkbox"]')) syncArtwork();
    });
    document.addEventListener('io:layout', syncArtwork);
    document.addEventListener('pdp:pricing-updated', syncArtwork);

    // Infinite Options may insert or replace a preselected checkbox after the
    // visualiser boots. Observe its container, not the visualiser we update.
    var options = document.getElementById('infiniteoptions-container');
    if (premadeRoot && options) {
      new MutationObserver(syncArtwork).observe(options, { childList: true, subtree: true });
    }
  });
})();
